module.exports = __webpack_public_path__ + "img/thumbnail_WhiteFacedSaki_j_normal.08699d97.png";